import { z } from "zod";

export const projectEquipmentItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const projectEquipmentsResponseSchema = z.object({
  results: z.array(projectEquipmentItemSchema),
});

export type ProjectEquipmentItem = z.infer<typeof projectEquipmentItemSchema>;
export type ProjectEquipmentsResponse = z.infer<typeof projectEquipmentsResponseSchema>;
